import '@/shared/styles/index.css';
import '@theguarantors/tg-package-material-ui/dist/fonts/index.css';
import '@/shared/styles/font-override.css';

import { bootstrapApplication } from '@/bootstrap';

bootstrapApplication();
